import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ArrayModel, ColumnModel, TableModel, TableModelOptions } from '@evorait/pace-core';
import { PIMeasurementToolModel } from '../../models/pi-measurement-tool.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'pace-pi-measurement-tool',
    templateUrl: './pi-measurement-tool.component.html',
    standalone: false,
})
export class PIMeasurementToolComponent implements OnInit {
    @Input()
    public model: ArrayModel<PIMeasurementToolModel>;
    @Input()
    public parentForm: FormArray;

    public tableModel: TableModel<PIMeasurementToolModel>;
    public formChildren: FormArray;
    public pIMeasurementToolForm: FormGroup;

    public constructor(
        private translate: TranslateService,
        private readonly formBuilder: FormBuilder,
    ) {}

    public ngOnInit(): void {
        this.formChildren = this.formBuilder.array([]);
        this.pIMeasurementToolForm = this.formBuilder.group({
            formChildren: this.formChildren,
        });
        this.parentForm.push(this.pIMeasurementToolForm);

        const columns: ColumnModel[] = [];
        columns.push(
            new ColumnModel(
                <string>this.translate.instant('PHYSICAL_INVENTORY_DESCRIPTION_LABEL'),
                'equipmentDesc.value',
            ),
        );
        columns.push(
            new ColumnModel(
                <string>this.translate.instant('PHYSICAL_INVENTORY_MEASUREMENT_TOOL_EQUIPMENT_NO_LABEL'),
                'equipNo.value',
            ),
        );
        const tableOptions = new TableModelOptions({ columns, sortColumn: 'pos' });

        this.tableModel = new TableModel<PIMeasurementToolModel>(this.model.value, tableOptions);
    }

    public addMeasurementTool(): void {
        this.model.addModel(new PIMeasurementToolModel());
    }

    public deleteMeasurementTool(index: number): void {
        this.model.removeModel(index);
    }

    public validateMeasurementTool(index: number, control: AbstractControl): void {
        this.model.getModelByIndex(index).evaluateMandatoryFields();
        control.updateValueAndValidity();
    }
}
